module.exports = __webpack_public_path__ + "static/media/openMsg.32a90ed7.svg";